var exports = {
  "k": "xfd349460--bb9e82--container",
};

module.exports = exports;
